"use strict";
exports.__esModule = true;
exports.streamEvent = void 0;
var common_client_header_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/client/common_client_header");
var region_1 = require("../region");
var logger_1 = require("../logger");
var grapheneMetrics_1 = require("../grapheneMetrics");
var environment_1 = require("../environment");
var spectrumUtils_1 = require("../util/spectrumUtils");
var spectrumHeader_1 = require("../metadata/spectrumHeader");
var debug_1 = require("../debug");
var log = (0, logger_1.getLogger)("streamEvent");
function streamEvent(event, region) {
    if (region === void 0) { region = common_client_header_1.Region.REGION_UNSET; }
    if (!eventAndRegionValid(event, region)) {
        return;
    }
    var eventName = (0, spectrumUtils_1.getSpectrumEventName)(event);
    var finalDestinationRegion = (0, region_1.getActualDestinationRegion)(region);
    (0, debug_1.logDebugAction)({ type: "SpectrumEventLogged", event: event });
    log.info("Logging Spectrum event", eventName, "for region", finalDestinationRegion);
    var header = (0, spectrumHeader_1.getSpectrumHeader)();
    enqueueItemsToQueues([header, event]);
}
exports.streamEvent = streamEvent;
function eventAndRegionValid(event, region) {
    if (event.event === undefined) {
        log.error("Spectrum event must be specified!");
        return false;
    }
    else if (!(0, region_1.spectrumEventValidRegion)(event, region)) {
        logEventInvalidRegion(event);
        return false;
    }
    return true;
}
function logEventInvalidRegion(event) {
    var _a;
    grapheneMetrics_1.blizzardGraphene.increment({
        metricsName: grapheneMetrics_1.SPECTRUM_INVALID_REGION,
        dimensions: {
            name: (0, spectrumUtils_1.getSpectrumEventName)(event),
            app: (_a = (0, environment_1.getAppEnvironment)().application) !== null && _a !== void 0 ? _a : ""
        }
    });
    log.error("Event", (0, spectrumUtils_1.getSpectrumEventName)(event), "has specified an invalid region. Make sure it is allowlisted for Spectrum region forwarding if regionalization is actually required for this event.");
}
function enqueueItemsToQueues(items) {
    log.info("Enqueueing", items.length, "Spectrum items to queue(s)...");
}
//# sourceMappingURL=index.js.map